import { Component, OnInit } from '@angular/core';

import { fromEvent } from 'rxjs/internal/observable/fromEvent';
// import { saveDocument } from '../assets/js/textcontrol.js';
// import { saveDocument, loadDocument } from '../assets/js/custom.js';
declare const saveDocument: any;
declare const loadDocument: any;
declare const TXTextControl: any;


@Component({
  selector: 'app-example-text-control',
  templateUrl: './example-text-control.component.html',
  styleUrls: ['./example-text-control.component.scss']
})
export class ExampleTextControlComponent implements OnInit {

  accessToken: string = '12388-22132-12133';
  
//   onClickSave() {
//     saveDocument();
// }
  title?: any;
  username = "tsa-textControlvBeta";
  place = "pune";
  date = "29-06-1989";
  isUserNameFieldExist = false;
  editor = false;
f_subject_number = '1001.1.1.10';

job_plaintiff_name = "Nick Bowen";
subject_1_name = "Samy Newman";
job_document_number = '1.0.0.1';

  placeholders = ["username", "date", "place", "job_plaintiff_name", "subject_1_name", "job_document_number" ];
  formField: any;
  new_placeholder?: string | any;


  constructor() { }

  ngOnInit(): void {

    this.username = 'my-text-control - TSA - tsa-textControlvBeta';
  }



  openDocument(e: any) {
    this.readDocument(e);
    TXTextControl.enableCommands();

    TXTextControl.addEventListener("textFieldEntered", function(e: any) {
      // TXTextControl.sendCommand(
      //   TXTextControl.Command.EditMode,
      //   TXTextControl.EditMode.Edit
      // );
    });

    TXTextControl.addEventListener("textFieldLeft", function(e: any) {
      // TXTextControl.sendCommand(
      //   TXTextControl.Command.EditMode,
      //   TXTextControl.EditMode.ReadAndSelect
      // );
    });
  }




  readDocument(input: any) {
    if (input.target.files && input.target.files[0]) {
      var fileReader = new FileReader();
      fileReader.onload = (e: any) => {
        var streamType = TXTextControl.streamType.PlainText;

        // set the StreamType based on the lower case extension
        switch (
          input.target.value
            .split(".")
            .pop()
            .toLowerCase()
        ) {
          case "doc":
            streamType = TXTextControl.streamType.MSWord;
            break;
          case "docx":
            streamType = TXTextControl.streamType.WordprocessingML;
            break;
          case "rtf":
            streamType = TXTextControl.streamType.RichTextFormat;
            break;
          case "htm":
            streamType = TXTextControl.streamType.HTMLFormat;
            break;
          case "tx":
            streamType = TXTextControl.streamType.InternalUnicodeFormat;
            break;
          case "pdf":
            streamType = TXTextControl.streamType.AdobePDF;
            break;
        }

        // load the document beginning at the Base64 data (split at comma)
        TXTextControl.loadDocument(streamType, e.target.result.split(",")[1]);
         TXTextControl.sendCommand(
          TXTextControl.Command.EditMode,
          // TXTextControl.EditMode.ReadAndSelect
          TXTextControl.EditMode.Edit
        );
        
      };

      // read the file and convert it to Base64
      fileReader.readAsDataURL(input.target.files[0]);
    }
  }


// this is how I can run over my template variables live.... ( just setup my new biding code and we can see it run live.... and then simply edit and save all in one step!!!!!!)
  async setInputs(item: any, placeholder:any) {
    await new Promise(resolve => {
      item.find(`{{${placeholder}}}`, 0, 0, (r: any) => {
            console.log(r);
            TXTextControl.selection.setText("");
            TXTextControl.selection.setStart(r, () => {
            TXTextControl.formFields.addTextFormField(1000, (f: { setText: (arg0: any[]) => void; setName: (arg0: any) => void; }) => {
                this.isUserNameFieldExist = true;
                f.setText(this[placeholder]);
                f.setName(placeholder);
                resolve(placeholder);
            });
            });
          });
    })
     
  }

  async setViewerInputs(item: any, placeholder: any) {
    await new Promise(resolve => {
      item.find(`{{${placeholder}}}`, 0, 0, (r: any) => {
            TXTextControl.selection.setText(this[item]);
            resolve("done")
          });
    })
     
  }


  bindViewer() {
    TXTextControl.textParts.forEach( async(item: any, i: any) => {
     if (item.find && i === 0) {
       for (let i=0; i<this.placeholders.length; i++) {
         await  this.setViewerInputs(item, this.placeholders[i]);
       }
     }
   });
 }

 bind() {
  
   TXTextControl.textParts.forEach( async(item: any, i: any) => {
     if (item.find && i === 0) {
       for (let i=0; i<this.placeholders.length; i++) {
         await  this.setInputs(item, this.placeholders[i]);
       }

       this.editor = true;
     }
   });

   // TXTextControl.getSubTextParts(function(r) {
   //   console.log(r)
   // })

   // TXTextControl.getTextParts(function(r) {
   //   console.log(r)
   // })

   // TXTextControl.getText(function(r) {
   //   console.log(r)
   // })
 }



// TSA

 bindTsaVars() {
  TXTextControl.textParts.forEach( async(item: any, i: any) => {
    if (item.find && i === 0) {
      for (let i=0; i<this.placeholders.length; i++) {
        await  this.setInputsTsaVars(item, this.placeholders[i]);
      }

      this.editor = true;
    }
  });

  // TXTextControl.getSubTextParts(function(r) {
  //   console.log(r)
  // })

  // TXTextControl.getTextParts(function(r) {
  //   console.log(r)
  // })

  // TXTextControl.getText(function(r) {
  //   console.log(r)
  // })
}


// :: WORKING VARS REPLACEMENT WORKING -- 
// this is how I can run over my template variables live.... ( just setup my new biding code and we can see it run live.... and then simply edit and save all in one step!!!!!!)
async setInputsTsaVars(item: any, placeholder:any) {
  await new Promise(resolve => {
    item.find( '$' + `{${placeholder}}`, 0, 0, (r: any) => {
          console.log(r);
          TXTextControl.selection.setText("");
          TXTextControl.selection.setStart(r, () => {
          TXTextControl.formFields.addTextFormField(1000, (f: { setText: (arg0: any[]) => void; setName: (arg0: any) => void; }) => {
              this.isUserNameFieldExist = true;
              f.setText(this[placeholder]);
              f.setName(placeholder);
              resolve(placeholder);
          });
          });
        });
  })
   
}

// BKUP working version below.

      // // this is how I can run over my template variables live.... ( just setup my new biding code and we can see it run live.... and then simply edit and save all in one step!!!!!!)
      // async setInputsTsaVars(item: any, placeholder:any) {
      //   await new Promise(resolve => {
      //     item.find( `{{${placeholder}}}`, 0, 0, (r: any) => {
      //           console.log(r);
      //           TXTextControl.selection.setText("");
      //           TXTextControl.selection.setStart(r, () => {
      //           TXTextControl.formFields.addTextFormField(1000, (f: { setText: (arg0: any[]) => void; setName: (arg0: any) => void; }) => {
      //               this.isUserNameFieldExist = true;
      //               f.setText(this[placeholder]);
      //               f.setName(placeholder);
      //               resolve(placeholder);
      //           });
      //           });
      //         });
      //   })
        
      // }



 onClickSave(prop: any) {
  const source = fromEvent(TXTextControl, "textFieldChanged");
  source.subscribe((f: any) => {
    // if(f.textField.name === 'username') {
    //   this.username = f.textField.text;
    // }

    console.log("changes");
  });

  if (!this.isUserNameFieldExist) {
    TXTextControl.formFields.addTextFormField(1000, (f: { setText: (arg0: any) => void; setName: (arg0: any) => void; }) => {
      this.isUserNameFieldExist = true;
      f.setText(prop);
      f.setName(prop);
    });
  } else {
    TXTextControl.formFields.forEach((formField: { getName: (arg0: (formFieldName: any) => void) => void; setText: (arg0: any) => void; }) => {
      formField.getName((formFieldName: any) => {
        if (formFieldName === prop) {
          formField.setText(prop);
        }
      });
    });
  }
}



// I need three apps built custom to make this work.
saveDocument_Base() {
  TXTextControl.saveDocument(TXTextControl.StreamType.HTMLFormat,
      function (e:any) {
          console.log(e.data);
          console.log('This is saving........ This is where the Node. Js');
          alert('now need to build a node js app to do the websocket to talk to the API backend TCP service.')
      });
}

  

saveDocumentAsAdobePDF(){

      // save the document as PDF
      TXTextControl.saveDocument(TXTextControl.StreamType.AdobePDF, function (e:any) {
        let bDocument = e.data;
        // create temporary link to download document
        var element = document.createElement('a');
        element.setAttribute('href', 'data:application/octet-stream;base64,' + bDocument);
        element.setAttribute('download', "results.pdf");
      
        element.style.display = 'none';
        document.body.appendChild(element);
      
        // simulate click
        element.click();
      
        // remove the link
        document.body.removeChild(element);
        });

}


saveDocumentAsWordprocessingML(){

  // save the document as PDF
  TXTextControl.saveDocument(TXTextControl.StreamType.WordprocessingML, function (e:any) {
    let bDocument = e.data;
    // create temporary link to download document
    var element = document.createElement('a');
    element.setAttribute('href', 'data:application/octet-stream;base64,' + bDocument);
    element.setAttribute('download', "results.docx");
  
    element.style.display = 'none';
    document.body.appendChild(element);
  
    // simulate click
    element.click();
  
    // remove the link
    document.body.removeChild(element);
    });

}


saveDocumentAsMSWord(){

  // save the document as PDF
  TXTextControl.saveDocument(TXTextControl.StreamType.MSWord, function (e:any) {
    let bDocument = e.data;
    // create temporary link to download document
    var element = document.createElement('a');
    element.setAttribute('href', 'data:application/octet-stream;base64,' + bDocument);
    element.setAttribute('download', "results.doc");
  
    element.style.display = 'none';
    document.body.appendChild(element);
  
    // simulate click
    element.click();
  
    // remove the link
    document.body.removeChild(element);
    });

}



saveDocumentAsHTMLFormat(){

  // save the document as PDF
  TXTextControl.saveDocument(TXTextControl.StreamType.HTMLFormat, function (e:any) {
    let bDocument = e.data;
    // create temporary link to download document
    var element = document.createElement('a');
    element.setAttribute('href', 'data:application/octet-stream;base64,' + bDocument);
    element.setAttribute('download', "results.html");
  
    element.style.display = 'none';
    document.body.appendChild(element);
  
    // simulate click
    element.click();
  
    // remove the link
    document.body.removeChild(element);
    });

}



saveDocumentAsSpreadsheetMLt(){

  // save the document as PDF
  TXTextControl.saveDocument(TXTextControl.StreamType.SpreadsheetML, function (e:any) {
    let bDocument = e.data;
    // create temporary link to download document
    var element = document.createElement('a');
    element.setAttribute('href', 'data:application/octet-stream;base64,' + bDocument);
    element.setAttribute('download', "results.xml");
  
    element.style.display = 'none';
    document.body.appendChild(element);
  
    // simulate click
    element.click();
  
    // remove the link
    document.body.removeChild(element);
    });

}



saveDocumentAsRichTextFormat(){

  // save the document as PDF
  TXTextControl.saveDocument(TXTextControl.StreamType.RichTextFormat, function (e:any) {
    let bDocument = e.data;
    // create temporary link to download document
    var element = document.createElement('a');
    element.setAttribute('href', 'data:application/octet-stream;base64,' + bDocument);
    element.setAttribute('download', "results.rtf");
  
    element.style.display = 'none';
    document.body.appendChild(element);
  
    // simulate click
    element.click();
  
    // remove the link
    document.body.removeChild(element);
    });

}


saveDocumentAsPlainText(){

  // save the document as PDF
  TXTextControl.saveDocument(TXTextControl.StreamType.PlainText, function (e:any) {
    let bDocument = e.data;
    // create temporary link to download document
    var element = document.createElement('a');
    element.setAttribute('href', 'data:application/octet-stream;base64,' + bDocument);
    element.setAttribute('download', "results.txt");
  
    element.style.display = 'none';
    document.body.appendChild(element);
  
    // simulate click
    element.click();
  
    // remove the link
    document.body.removeChild(element);
    });

}



saveDocumentAsInternalUnicodeFormat(){

  // save the document as PDF
  TXTextControl.saveDocument(TXTextControl.StreamType.InternalUnicodeFormat, function (e:any) {
    let bDocument = e.data;
    // create temporary link to download document
    var element = document.createElement('a');
    element.setAttribute('href', 'data:application/octet-stream;base64,' + bDocument);
    element.setAttribute('download', "results.xlxs");
  
    element.style.display = 'none';
    document.body.appendChild(element);
  
    // simulate click
    element.click();
  
    // remove the link
    document.body.removeChild(element);
    });

}






}
